import React from 'react'
import Footer from '../../Footer'
import fig1 from '../../../img/tech/speaker/1.png'
import fig2 from '../../../img/tech/speaker/2.png'
import fig3 from '../../../img/tech/speaker/3.png'
import '../Proj.css'


export default class ProjAshore extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div className='proj-wrap-86'>
                    <div id='texel-title'>
                        <h1>Sound of the sea speaker</h1>
                    </div>
                    <p className='little-title'>Cooperating with Industrial Designer TING-WU CHEN and YONG-QING YANG, and in a technical team with three team members in total.</p>
                    <p>
                        This speaker is made of ocean garbage and it broadcasts the sound live-recodred from seashores.
                        <br/>
                        I am responsible for <b>implementing the controlling sofware</b> and the <b> interactive mechanism of the speaker,</b>
                        while the connection to broadcast the sound from seashore is implemented by the other two teammates.
                    </p>
                    <div className='proj-fig1'>
                        <img src={fig1} />
                    </div>
                    <p className='little-title'>Interactions of the speaker</p>
                    <p>
                        Inside the speaker, there is a capacitive touch sensing panel and a Rasberry Pi 3(RPi).
                        The touch panel communicates with RPi through serial port.
                        When the speaker is activated (pressed down as shown below), the speaker automatically turns on.
                    </p>
                    <div className='proj-fig1'>
                        <img src={fig2} />
                    </div>
                    <p>
                        When the speaker is in use, the outer layer(as shown below) slowly rotates, 
                        and the LEDs inside lighten and darken in a slow and gentle pace, just like sea waves. We hope the calming sound of waves can bring peace and relaxness to the busy modern world.
                    </p>
                    <div className='proj-fig1'>
                        <img src={fig3} />
                    </div>
                    
                    <Footer back={true}/>
                </div>
                
            </div>
        )
    }
}